/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 活动 ID
   */
  event_id: string;
  /**
   * 报错项类型
   */
  error_type: string;
}
export interface DashboardEventDealWithPublishErrorRes {
  msg: string;
  nonce: string;
  code: string;
}

const DashboardEventDealWithPublishError = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<DashboardEventDealWithPublishErrorRes>(
    '/wemeet-tapi',
    '/v2/activities/dashboard/event/deal-with-publish-error',
    data,
    ctx,
  );

  return res;
};

export default DashboardEventDealWithPublishError;
